export type Locale = 'en' | 'ja' | 'vi';

export const LOCALES: { code: Locale; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'ja', label: '日本語' },
  { code: 'vi', label: 'Tiếng Việt' },
];

export const LOCALE_STORAGE_KEY = 'nhaudee-web-locale';

export type Messages = Record<string, string>;

export type TranslateFn = (key: string, vars?: Record<string, string | number>) => string;

export function legalPath(locale: Locale, page: 'help' | 'privacy' | 'terms'): string {
  if (locale === 'en') return `/${page}/`;
  return `/${locale}/${page}/`;
}
